export enum EvaluationType {
  Evaluation = 'evaluation meeting',
  EndOfProbation = 'end of probation meeting',
}
